import OutboundOrdersStatusChip from "./OutboundOrdersStatusChip.jsx";
import OutboundOrdersCheckbox from "./OutboundOrdersCheckbox.jsx";
import OutboundOrdersParts from "./OutboundOrdersParts.jsx";

const sortable = true;
export const items = [
  {
    id: "customer.name",
    label: "Customer",
  },
  {
    id: "poNumber",
    label: "PO #",
  },
  {
    id: "partNumber",
    label: "Parts",
  },
  {
    id: "dueDate",
    label: "Due Date",
    sortable,
  },
  {
    id: "shipDate",
    label: "Ship Date",
  },
  {
    id: "createdAt",
    label: "Created At",
    sortable,
  },
  {
    id: "status",
    label: "Status",
  },
];

export const keys = [
  {
    value: "isChecked",
    variant: "small",
    CustomComponent: OutboundOrdersCheckbox,
  },
  {
    variant: "blueBold",
    value: "customer.name",
    navigate: true,
    route: "customers",
    id: "customer.id",
  },
  {
    variant: "blueBold",
    value: "poNumber",
    navigate: true,
    route: "orders",
    id: "id",
  },
  {
    value: "parts",
    CustomComponent: OutboundOrdersParts,
  },
  {
    value: "dueDate",
    isDate: true,
  },
  {
    value: "shipDate",
    isDate: true,
  },
  {
    value: "createdAt",
    isDate: true,
  },
  {
    value: "status",
    isChip: true,
    CustomComponent: OutboundOrdersStatusChip,
  },
];
